import {createSlice} from '@reduxjs/toolkit'

export const addTableColumnSlice = createSlice({
  name: 'prospectSegmentation',
  initialState: {
    defaultValue: [],
    prospectListColumn: []
  },
  reducers: {
    getAllColumns: (state, action) => {
      state.prospectListColumn = action.payload
    },
    addColumn: (state, action) => {
      state.defaultValue = action.payload
    },
    getDefaultColumns: (state, action) => {
      state.defaultValue = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {addColumn, getAllColumns, getDefaultColumns} = addTableColumnSlice.actions

export default addTableColumnSlice.reducer
